<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  mounted() {
    // console.log(this.$route.name)
    // if (this.$route.name.slice(0, 1) == "P") {
    //   document.documentElement.style.fontSize = "16px";
    // } else {
      document.documentElement.style.fontSize = this.myrem();
      window.onresize = () => {
        document.documentElement.style.fontSize = this.myrem();
      };
    // }
  },
  methods: {
    myrem() {
      let myW = document.body.clientWidth * 2;
      let rem = (myW * 100) / 750 + "px";
      return rem;
    },
  },
};
</script>

<style>
* {
  margin: 0 0;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
  font-family: "Microsoft YaHei", "STHeiti Light", Arial, sans-serif;
  font-size: 0.16rem;
  -webkit-text-size-adjust: none;
}
.PcStyle {
  font-size: 16px;
  height: calc(100% - 90px);
}
.index-outer {
  height: 100%;
}
/* @media screen and (min-width: 768px) {
  html,
  body,
  #app {
    width: 768px;
    margin: 0 auto;
  }
}
 */

 .el-message {
  font-size: 14px;
}
</style>
